import { Textarea } from '@/components/ui/textarea';
import type { ArgumentInputProps } from './types';

export function TextareaInput({ arg, onChange, isError }: ArgumentInputProps) {
  const hasError = isError && arg.is_required && !String(arg.value).trim();

  return (
    <Textarea
      value={String(arg.value)}
      onChange={(e) => onChange(e.target.value)}
      placeholder={arg.placeholder || 'Enter text'}
      className={`min-h-[80px] ${hasError ? 'border-destructive' : ''}`}
      id={arg.name}
    />
  );
}
